import React from 'react';
import { useNavigate } from "react-router-dom";
import Question from "../../components/Question";
import { Box, Typography } from "@mui/material";
import { PaymentElement } from "@stripe/react-stripe-js";
import { usePay } from "../../hooks/usePay";
import ContinueButton from '../../components/ContinueButton';
import { continueButtonSx } from '../../lib/uiformatting';
import { useDispatch, useSelector } from "react-redux";
import { setFiredPurchaseEvent } from "../../redux/stripeSlice";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function CardFile(props) {
  const next = "/photos";
  const [handlePay, message, isLoading, paid, payOptions, isFormComplete] = usePay(next, false);
  const user = useSelector((state) => state.user);
  const firedPurchaseEvent = useSelector((state) => state.stripe.firedPurchaseEvent);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    setPageAndDeferNavigate(dispatch, '/allergies', navigate);
  };

  return (
    <Question
      onBack={handleBack}
      title={"Great! We just need a credit card on file."}
      subtitle={
        paid
          ? "Your card is on file. You're all set"
          : "We usually charge your co-pay at the same time as your case is reviewed. We'll notify you if there are any additional costs related to your insurance."
      }
      input={
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
          {!paid && (
            <Box sx={{ mb: "2rem", width: "100%", maxWidth: "400px" }}>
              <PaymentElement id="payment-element" options={payOptions} />

            </Box>
          )}
        </Box>
      }
      footer={
        <Box
          sx={{
            ...continueButtonSx,
            position: "sticky",
            bottom: 0,
          }}
        >
          {!paid ? (
            <Box sx={{
              mt: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              zIndex: 9999,
            }}>
              <ContinueButton
                onClick={() => {
                  if (process.env.REACT_APP_OURS_EVENT) {
                    if (firedPurchaseEvent === false) {
                      // eslint-disable-next-line no-undef
                      ours('track', 'Purchase', { value: 119, currency: 'USD' }, {
                        email: user.email,
                        phone_number: user.phoneNo
                      });
                      dispatch(setFiredPurchaseEvent(true));
                    }
                  }
                  handlePay();
                }}
                title="Save Payment Details"
                disabled={isLoading || !isFormComplete}
                selected={!isLoading && isFormComplete}
              />
              <Typography
                variant="caption"
                sx={{
                  mt: "0.5rem",
                  width: '100%',
                  textAlign: "center"
                }}
              >
                We'll place a $1 hold for verification.
                {/* TODO: modify wording to be more accurate - $1 is authorized, but not captured */}
              </Typography>
            </Box>
          ) : (
            <ContinueButton
              onClick={() => setPageAndDeferNavigate(dispatch, next, navigate)}
              title="Continue"
              disabled={!paid}
              selected={paid}
            />
          )}
        </Box>
      }
    />
  );
}
